export default __webpack_public_path__ + "static/media/passwords_6.8b30b443.png";